<script>
	export let id;
	export let user;
	export let type;
	export let descriptionTooltip = false;
	export let start;
	export let end;
	export let half;
	export let accepted_by_team_leader;
	export let accepted_by_ceo;
	export let requested_time;
	export let approvable;
	export let position; //odd or even

    import { post } from "../js/labit-connection";
	import { createEventDispatcher } from "svelte";

	const dispatch = createEventDispatcher();

	function dispatchBtnClick() {
		dispatch("dispatchedClick");
	}

	let bgColor = position % 2 === 0 ? "#d7e1ea3d" : "#fff";
	
	$: if (accepted_by_ceo === "Yes") {
		bgColor = "rgb(82 232 87 / 13%)";
	} else if (accepted_by_ceo === "No") {
		bgColor = "rgb(232 82 82 / 13%)";
	}

	let sameDay = null;
	let halfTooltip;
	
	start = moment(start, "x");
	end = moment(end, "x");
	requested_time = moment(requested_time, "x");
	
	if (start.isSame(end, "day")) {
		sameDay = "sameDay";
		if (half !== "0") {
			halfTooltip = half === "1" ? "First half" : "Second half";
		} else {
			//halfTooltip = moment.duration(end.diff(start), "ms").format("hh:mm");
			halfTooltip = `${start.format("HH:mm")} to ${end.format("HH:mm")}`;
		}
	}

	let absenceResponse = async (id, accepted) => {
		let query = `update absences set accepted_by_ceo = "${accepted}" where id = ${id};`
        await post(query);

		dispatchBtnClick();
	}

</script>

<tr class="" style="background-color:{bgColor}">
	<td>{user}</td>
	<td>
		<span data-tooltip={descriptionTooltip}>{type}</span>
	</td>
	<td>{start.format("DD/MM/YYYY")}</td>
	<!-- <td>{end.format("DD/MM/YYYY")}</td> -->
	<td>
		<div data-tooltip={halfTooltip} style="margin:auto" class="date {sameDay}"> <span>{end.format("DD/MM/YYYY")}</span> </div>
	</td>
	<td>{accepted_by_team_leader}</td>
	<td>{accepted_by_ceo}</td>
	<td>{requested_time.format("DD/MM/YYYY HH:mm")}</td>
	<td>{approvable}</td>
	<td>
		<div style="margin:auto">
			{#if id != -1 && approvable != "No"}
				<button on:click={ () => absenceResponse(id, "1") } class="pointer accept">Accept</button>
				<button on:click={ () => absenceResponse(id, "-1") } class="pointer decline">Decline</button>
			{/if}
		</div>
	</td>
</tr> 

<!--
<div class="container flex w-100" style="background-color:{bgColor}">
	<div class="name"> <span>{user}</span> </div>
	<div data-tooltip={descriptionTooltip} class="type"> <span>{type}</span> </div>
	<div class="date"> <span>{start.format("DD/MM/YYYY")}</span> </div>
	<div data-tooltip={halfTooltip} class="date {sameDay}"> <span>{end.format("DD/MM/YYYY")}</span> </div>
	<div class="bool"> <span>{accepted_by_team_leader}</span> </div>
	<div class="bool"> <span>{accepted_by_ceo}</span> </div>
	<div class="datetime"> <span>{requested_time}</span> </div>
	<div class="bool"> <span>{approvable}</span> </div>
	{#if id != -1 && approvable != "No"}
		<button on:click={ () => absenceResponse(id, "1") } class="pointer accept">Accept</button>
		<button on:click={ () => absenceResponse(id, "-1") } class="pointer decline">Decline</button>
	{/if}
</div>
-->

<style>

	tr td {
		text-align: center;
	}

	button {
		margin: 0 5px;
		border: none;
		border-radius: 6px;
	}

	.accept {
		background-color: #a1ff906e;
	}

	.decline {
		background-color: #ff90906e;
	}

	.pointer {
        cursor: pointer;
	}

	.flex {
		align-items: center;
		/*justify-content: space-between;*/
		display: flex;
	}

	.w-100 {
		width: 100% !important;
	}

	.name {
		width: 110px;
		border: none !important;
	}

	.type {
		width: 190px;
	}
	
	.date {
		width: 95px;
	}
	
	.bool {
		width: 170px;
	}
	
	.datetime {
		width: 170px;
	}

	.sameDay {
		background-color: #cfe8ff;
	}

</style>